import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ReportService } from 'src/Services/report.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefings-yearly-report',
  templateUrl: './briefings-yearly-report.component.html',
  styleUrls: ['./briefings-yearly-report.component.css']
})
export class BriefingsYearlyReportComponent {

  loginuserID: any;
  isloading = false;
  SelectedTool = '';
  tokenKey: string = '';

  dropdownListYear = [];
  selectedItemsYear = [];
  dropdownSettingsYear = {};
  listOfYearIds = [];
  selectedYear: number = 0;
  isData: boolean = false;

  selectYearBriefingsData: any = [];
  isShowprogressSpinner: boolean = false;
  blockedDocument: boolean = false;
  briefingFinalResult: any = [];
  isBrifingFinalResult: boolean = false;

  constructor(private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Briefings Yearly Report');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();

    this.dropdownSettingsYear = {
      singleSelection: true,
      text: "Select Year",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Year available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    this.GetYearFromBriefingMaster();
  }

  GetYearFromBriefingMaster() {
    this.isloading = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.reportService.GetYearFromBriefingMaster(this.tokenKey).subscribe(data => {
      this.isloading = false;
      this.isShowprogressSpinner = false;
      this.blockedDocument = false;
      if (data) {
        if (data.status == "Success") {
          for (const yearData of data["yearList"]) {
            this.dropdownListYear.push(
              { "id": yearData.year, "itemName": yearData.year }
            );
          }
        }
      }
    })
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  onSelectYear($event) {
    this.selectedYear = $event.id;
    this.GetBriefingsDataByYear();
  }

  onDeSelectYear($event) {
    this.selectedYear = 0;
  }

  onDeSelectAllYear($event) {
    this.selectedYear = 0;
    this.selectYearBriefingsData = [];
    this.briefingFinalResult = [];
    this.isData = false;
    this.isBrifingFinalResult = false;
  }

  GetBriefingsDataByYear() {
    if (this.selectedYear === 0) {
      return;
    }

    this.setLoadingState(true);

    this.reportService.GetBriefingsDataByYear(this.tokenKey, this.selectedYear).subscribe(data => {
      this.setLoadingState(false);

      if (data.status == "Success") {
        this.handleSuccessResponse(data);
      }
    });
  }

  setLoadingState(isLoading: boolean) {
    this.isloading = isLoading;
    this.isShowprogressSpinner = isLoading;
    this.blockedDocument = isLoading;
  }

  handleSuccessResponse(data: any) {
    this.selectYearBriefingsData = data["briefingsData"];
    this.briefingFinalResult = data["briefingFinalResult"];

    this.isData = this.selectYearBriefingsData.length > 0;
    this.isBrifingFinalResult = this.briefingFinalResult.length > 0;
  }

  DownloadBriefingsYearlyReport() {
    if (this.selectYearBriefingsData.length > 0) {
      let tableData = document.getElementById("ExportTable").innerHTML;

      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
        , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
      let html = "<table><tr class='mainhead'> <td colspan='3'>";
      html += tableData;
      html += "</td></tr></table>";
      let name = 'ExportBriefingsYearlyReport';
      var ctx = { worksheet: name || 'Worksheet', table: html }
      FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportBriefingsYearlyReport.xls");
    }
    else {
      this.isloading = false;
      this.toastr.error("No record found", "Error");
    }
  }
}
